// components
import ArrayFieldItem from "./ArrayFieldItem"
import { useShallow } from "zustand/react/shallow"
import useAuthoringTranslations from "../../../../hooks/stores/useAuthoringTranslations"

const ArrayFieldTemplate = (props) => {
  const { uiSchema, idSchema, schema } = props
  const options = uiSchema["ui:options"]
  const jpath = idSchema.$id.split(".").join("_")

  const { isTranslationActive, selectedLanguage } = useAuthoringTranslations(
    useShallow((state) => ({
      isTranslationActive: state.isTranslationActive,
      selectedLanguage: state.selectedLanguage,
    }))
  )

  let title = "Title"
  let arrayItemTitle = "Item Title"
  let classNames = {}
  let showIndex = options?.showIndex

  if (options) {
    title = options.title
    arrayItemTitle = options.arrayItemTitle
    classNames = options.classNames
  }

  if (isTranslationActive && options?.translations?.[selectedLanguage]) {
    const langTranslation = options?.translations?.[selectedLanguage]

    if (langTranslation?.title) {
      title += ` (${langTranslation.title})`
    }
    if (langTranslation?.arrayItemTitle) {
      arrayItemTitle += ` (${langTranslation.arrayItemTitle})`
    }
  }

  return (
    <div
      id={jpath}
      className={`rjs-array-container ${classNames?.arrayContainer ? classNames.arrayContainer : ""}`}
    >
      {title && (
        <div className="rjs-array-title-container">
          <div className={`rjs-array-title ${classNames?.arrayTitle ? classNames.arrayTitle : ""}`}>{title}</div>
        </div>
      )}
      <div
        className={`rjs-array-items-container ${classNames?.arrayItemsContainer ? classNames.arrayItemsContainer : ""}`}
      >
        {props.items.map((element) => {
          return (
            <ArrayFieldItem
              key={element.key}
              element={element}
              classNames={classNames}
              arrayItemTitle={arrayItemTitle}
              showIndex={showIndex}
            />
          )
        })}
      </div>
    </div>
  )
}

export default ArrayFieldTemplate
